<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.Appearance"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | method: 'getSectionHeaderTextColor' : section)
  "
  class="section-header-general section-header-appearance">
  {{ menu | method: 'getTypeColumnTitle' : colVm }}
</div>
